import React from 'react';
import { usePublicTasks } from '../../../firebase/api/tasks-public';
import { BoardsPreloader } from './styled';
import TaskItem from './TaskItem';

const ReadyTasks: React.FC = () => {
  const frontBoardId = '0c86f929-36b2-46ca-80b1-2c63c4f9f64b';
  const backBoardId = '06e8a411-2087-471c-8b55-abebb683e02c';
  const { tasks: front, loading: loadingFront } = usePublicTasks(frontBoardId);
  const { tasks: back, loading: loadingBack } = usePublicTasks(backBoardId);

  const loading = loadingFront && loadingBack;

  return (
    <>
      {loading ? (
        <BoardsPreloader />
      ) : (
        <>
          {front
            .filter((el) => el.status === 'done')
            .map((t, index, self) => (
              <TaskItem
                {...t}
                key={t.id}
                self={self}
                index={index}
                boardId={frontBoardId}
                canBeTracked={false}
                setTrackingTaskId={() => null}
                trackingTaskId=""
              />
            ))}
          {back
            .filter((el) => el.status === 'done')
            .map((t, index, self) => (
              <TaskItem
                {...t}
                key={t.id}
                self={self}
                index={index}
                boardId={backBoardId}
                canBeTracked={false}
                setTrackingTaskId={() => null}
                trackingTaskId=""
              />
            ))}
        </>
      )}
    </>
  );
};

export default ReadyTasks;
